import { render, staticRenderFns } from "./CartInfo.vue?vue&type=template&id=4af9fe42&scoped=true&lang=pug&"
import script from "./CartInfo.vue?vue&type=script&lang=js&"
export * from "./CartInfo.vue?vue&type=script&lang=js&"
import style0 from "./CartInfo.vue?vue&type=style&index=0&id=4af9fe42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af9fe42",
  null
  
)

export default component.exports